
import axios from 'axios';

const instance = axios.create({
    headers: {'Authorization': `Bearer ${localStorage.getItem(process.env.REACT_APP_TOKEN)}`}
});
export default instance;